




























































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import HttpClient from "@/core/HttpResources/BaseHttpClient";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";
import Persona from "@/models/persona/persona.model";
import BaseVue from "@/core/BaseVue";
import SectionMobileComponent from "./ciudadano-section-mobile-subcomponent/section-component.mobile.vue";
import TipoTramiteComponentProp from '@/helpers/tipoTramiteComponentProp.helper';
import MobilePerfilComponent from '@/modules/mobile-template/mobile-perfil-component.vue';

@Component({
  components: { SectionMobileComponent, MobilePerfilComponent }
})
export default class PerfilCiudadanoMobilePerfil extends BaseVue {
  @Prop() public action!: string;
  @Prop() public controller!: string;
  @Prop() public value!: any;
  @Prop() public cedula!: string;
  @Prop() public clases!: string;
  @Prop() readonly esBeneficiario!: boolean;
  @Prop() readonly esMiembro!: boolean;

  private loading = false;
  private initModel = new Persona();
  private client = new HttpClient(this.controller || "personas");
  private ciudadano = this.map<Persona>(
    this.value ? this.value : this.initModel
  );
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "esBeneficiario",
        "boolean",
        true,
        "¿Es beneficiario?"
      )
    );
    props.push(
      new TipoTramiteComponentProp(
        "esMiembro",
        "boolean",
        true,
        "¿Es miembro de un hogar?"
      )
    );

    this.$emit("render", props);
  }
  get queryParamsc() {
    if (this.cedula) {
      let ced = this.cedula.replace(/-/g, "");
      return {
        cedula: ced
      };
    }
    return {
      cedula: ""
    };
  }

  async getDataAsync() {
    try {
      this.loading = true;
      let resource = this.action || "findorsyncjce";
      let result = await this.client.getAsync<any>(resource, this.queryParamsc);
      this.ciudadano = result;
      // this.$emit("input", result ? result.id : null);
      this.$emit("change", this.ciudadano);
    } catch (e) {
      this.ciudadano = this.map<Persona>(this.initModel);
      this.$emit("change", null);
      this.operationFailedErrors(e);
    } finally {
      this.loading = false;
    }
  }

  get nombreCiudadanoLineas() {
    const {
      nombre1 = "",
      nombre2 = "",
      apellido1 = "",
      apellido2 = ""
    } = this.ciudadano || {};

    if (nombre1 && nombre2 && apellido1 && apellido2) {
      return [
        `${nombre1} ${nombre2}`.trim(),
        `${apellido1} ${apellido2}`.trim()
      ];
    }

    return [[nombre1, nombre2, apellido1, apellido2].filter(Boolean).join(" ").trim()];
  }

  getFoto(value: string) {
    return `data:image/jpg;base64, ${value}`;
  }

  @Watch("value", { deep: true, immediate: true })
  OnValueChange(value: any) {
    if (!value) {
      this.ciudadano = this.map<Persona>(this.initModel);
      return;
    }
    if (value) {
      this.ciudadano = this.map<Persona>(this.value);
      this.$emit("change", value);
    }
  }

  @Watch("cedula", { immediate: true })
  onCedula(value: string) {
    if (!value) {
      this.ciudadano = this.map<Persona>(this.initModel);
      return;
    }
    if (Utils.isCedula(value)) this.getDataAsync();
  }
  goToTramite(persona: any) {
    if (persona.tieneHogar) this.$router.push(`nueva-solicitud`);
    else this.$router.push(`solicitud-de-evaluacion-del-hogar`);
  }
}
